export function getFilterSettings(
  defaultView,
  tableConfig,
  toSelectResponsables,
  tags
) {
  return [
    {
      name: 'status',
      filter_by: getFilterFor(defaultView, 'status'),
      values: getValuesFor(tableConfig, 'status'),
      type: 'icon'
    },
    {
      name: 'toSelectResponsibles',
      filter_by: getFilterFor('toSelectResponsibles'),
      values: toSelectResponsables,
      type: 'image'
    },
    {
      name: 'subtrade',
      filter_by: getFilterFor('subtrade'),
      values: getValuesFor(tableConfig, 'subcontractId'),
      type: 'icon'
    },
    {
      name: 'tags',
      filter_by: getFilterFor('tags'),
      values: tags,
      type: 'string'
    }
  ];
}

export function getFilterFor(defaultView, propName) {
  const filterValues =
    defaultView.current?.activityTreeSettings?.filters?.values;
  return filterValues?.find(({ name }) => name === propName)?.filter_by || [];
}

export function getValuesFor(tableConfig, propName) {
  return tableConfig.find(({ name }) => name === propName)?.from_values || [];
}
